// extracted by mini-css-extract-plugin
export var standaloneTable = "_f5-0";
export var standaloneTableWithBodyFill = "_f5-1";
export var withExtraHeader = "_f5-2";